import React from "react";
import { WorkspaceActiveProvider } from "@/components/NavigationSlotContext";

/**
 * Frame visual untuk satu instance tab workspace.
 *
 * Komponen ini hanya mengatur visibilitas dan aksesibilitas.
 * Navigasi per tab harus diintegrasikan pada lapisan router terpisah.
 */
export default function WorkspaceTabFrame({
  tabId,
  active,
  children,
}) {
  if (!tabId) return null;

  return (
    <section
      data-workspace-tab-id={tabId}
      role="tabpanel"
      aria-hidden={!active}
      hidden={!active}
      inert={!active ? "" : undefined}
      style={{
        display: active ? "block" : "none",
        minWidth: 0,
        minHeight: 0,
      }}
    >
      <WorkspaceActiveProvider active={active}>
        {children}
      </WorkspaceActiveProvider>
    </section>
  );
}
